<div class="flex flex-col items-center justify-center p-5">
  <div class="flex flex-row border-2 border-solid border-[#A5A6F6] h-[40px] rounded-[20px] overflow-hidden">
    <div
      class="bg-[#5D5FEF] px-[8px] py-[1px] text-white text-[26px] font-medium leading-[13px] flex items-center justify-center h-full"
    >
      IP {{userIndex | number: '1.0-2'}}
    </div>
    <div
      class="flex items-center justify-center bg-white flex-1 text-[#5D5FEF] font-semibold text-[23px] leading-[20px] px-[8px] py-[1px]"
    >
      +{{userIndexDiff | number: '1.0-2'}}
    </div>
  </div>
  <div 
    id="text-container"
    class="flex flex-col items-center justify-center mt-4 mb-5 text-[14px] leading-[18px] space-y-3">
    <p>
      Inspire Points (IP) reflect your overall impact, value and the community’s appreciation for your contributions. 
    </p>
    <p class="mt-3">
      Recent Activity (+{{userIndexDiff | number: '1.0-2'}}) highlights your recent actions and contributions within the last 30 days.
    </p>
  </div>
  <!-- <div class="flex flex-col gap-[31px]">
    <div class="flex flex-col">
      <div class="flex border-2 border-solid border-[#A5A6F6] w-[260px] h-[36px] rounded-[20px] overflow-hidden">
        <div class="bg-white flex items-center justify-start text-[16px] font-medium leading-[26px] flex-[2] pl-5 pr-3">
          Ambassador
        </div>
        <div class="bg-[#5D5FEF] flex items-center justify-center text-white text-[20px] font-semibold leading-[28px] flex-[1] h-full">
          {{userIndexAmbassador | number: '1.0-2'}}
        </div>
      </div>
      <p class="font-normal text-[13px] mt-1">Invite a person and they join</p>
    </div>

    <div class="flex flex-col">
      <div class="flex border-2 border-solid border-[#A5A6F6] w-[260px] h-[36px] rounded-[20px] overflow-hidden">
        <div class="bg-white flex items-center justify-start text-[16px] font-medium leading-[26px] flex-[2] pl-5 pr-3">
          Creator
        </div>
        <div class="bg-[#5D5FEF] flex items-center justify-center text-white text-[20px] font-semibold leading-[28px] flex-[1] h-full">
          {{userIndexCreator | number: '1.0-2'}}
        </div>
      </div>
      <p class="font-normal text-[13px] mt-1">Create content (Idea, Think Tank, Solution, Comment, Reply)</p>
    </div>

    <div class="flex flex-col">
      <div class="flex border-2 border-solid border-[#A5A6F6] w-[260px] h-[36px] rounded-[20px] overflow-hidden">
        <div class="bg-white flex items-center justify-start text-[16px] font-medium leading-[26px] flex-[2] pl-5 pr-3">
          Helper
        </div>
        <div class="bg-[#5D5FEF] flex items-center justify-center text-white text-[20px] font-semibold leading-[28px] flex-[1] h-full">
          {{userIndexHelper | number: '1.0-2'}}
        </div>
      </div>
      <p class="font-normal text-[13px] mt-1">Help other Members, Moderate, or Flag content</p>
    </div>
  </div> -->
</div>
